export default "__VITE_ASSET__C2hnSr90__"